import { IFBCallData } from "@sdk/fb-call-logs/fb-call-logs-model";
import { Avatar } from "components/common/avatar/avatar";
import { ContactAvatar } from "components/common/avatar/client-avatar";
import { loadContactById } from "store/modules/contacts/contacts.helpers";
import { selectContactById } from "store/modules/contacts/contacts.selectors";
import { useQueryWithStore } from "store/store.hooks";

/** Contact header for inbound/outbound Messenger calls. */
export const IncomingFBCallContactDetails = ({
  contactId,
  connectionId,
  callData,
  psid,
}: {
  contactId?: string;
  connectionId?: string;
  callData?: IFBCallData;
  psid?: string;
}) => {
  const { state: contact } = useQueryWithStore(
    selectContactById(contactId ?? ""),
    loadContactById(contactId ?? "")(),
    [contactId],
    !contactId,
  );

  const displayName =
    contact?.data?.firstName || contact?.data?.lastName
      ? [contact?.data?.firstName, contact?.data?.lastName]
          .filter(Boolean)
          .join(" ")
      : contact?.data?.primaryEmail ||
        psid ||
        callData?.from ||
        "Unknown contact";

  const subtitle =
    contact?.data?.primaryEmail ||
    contact?.data?.primaryMobile ||
    contact?.data?.phones?.[0]?.phone ||
    psid ||
    callData?.from;

  const showSubtitle = Boolean(subtitle) && subtitle !== displayName;
  const organization = contact?.data?.organization;

  return (
    <div className="flex items-center gap-3">
      {contactId ? (
        <ContactAvatar
          contactId={contactId}
          connectionId={connectionId}
          size={48}
        />
      ) : (
        <Avatar name={displayName} size={48} />
      )}
      <div className="min-w-0 flex-1">
        <div className="truncate font-semibold text-gray-900 dark:text-gray-100">
          {displayName}
        </div>
        {showSubtitle && (
          <div className="truncate text-sm text-gray-600 dark:text-gray-400">
            {subtitle}
          </div>
        )}
        {organization && (
          <div className="truncate text-xs text-gray-500 dark:text-gray-400">
            {organization}
          </div>
        )}
      </div>
    </div>
  );
};
